export const reviews = [
  {
    name: "Flabette Philogene Brene",
    company: { en: "Google review", es: "Reseña de Google" },
    quote: { en: "Great service, done in an hour.", es: "Excelente servicio, listo en una hora." },
    tag: { en: "Professional. Reliable. Always Ready.", es: "Profesional. Confiable. Siempre Listo." },
    service: { en: "Professional Staffing", es: "Personal Profesional" },
  },
  {
    name: "Hotel Operations Manager",
    company: { en: "Columbus hotel, 120 rooms", es: "Hotel en Columbus, 120 habitaciones" },
    quote: { en: "They covered our housekeeping gaps in a single week. Rooms are ready on time and the team communicates in English and Spanish with our supervisors.", es: "Cubrieron nuestras vacantes de limpieza en una semana. Las habitaciones están listas a tiempo y el equipo se comunica en inglés y español con nuestros supervisores." },
    tag: { en: "On time, every shift", es: "A tiempo, cada turno" },
    service: { en: "Hotel Housekeeping", es: "Limpieza de Hoteles" },
  },
  {
    name: "Office Manager",
    company: { en: "Professional services firm, Easton", es: "Firma de servicios profesionales, Easton" },
    quote: { en: "Our office has never looked this sharp. Same crew every night, detailed work and quick answers whenever we call.", es: "Nuestra oficina nunca se había visto tan bien. El mismo equipo cada noche, trabajo detallado y respuestas rápidas cuando llamamos." },
    tag: { en: "Consistent and detailed", es: "Constante y detallado" },
    service: { en: "Office Cleaning", es: "Limpieza de Oficinas" },
  },
  {
    name: "Restaurant Owner",
    company: { en: "Short North restaurant", es: "Restaurante en Short North" },
    quote: { en: "Reliable dishwashers who show up and work hard. Flexhire replaced a no-show the same morning — that saved our weekend.", es: "Lavaplatos confiables que llegan y trabajan duro. Flexhire reemplazó una ausencia esa misma mañana — eso salvó nuestro fin de semana." },
    tag: { en: "Fast replacements", es: "Reemplazos rápidos" },
    service: { en: "Kitchen & Dishwasher", es: "Cocina y Lavaplatos" },
  },
  {
    name: "Property Manager",
    company: { en: "Multi-family community, Clintonville", es: "Comunidad multifamiliar, Clintonville" },
    quote: { en: "Move-out turnovers are done fast and thoroughly. Our units are ready to show within a day.", es: "Las limpiezas de salida son rápidas y completas. Nuestras unidades están listas para mostrar en un día." },
    tag: { en: "Quality assured", es: "Calidad garantizada" },
    service: { en: "Apartment Cleaning", es: "Limpieza de Apartamentos" },
  },
];
